import { LinkTargetProperties } from "global/components/linkSettings/interfaces";
import { VideoSettingsData } from "widgets/commonDataObjects/interfaces";
import { SiteVideoData } from "widgets/interfaces";
import { convertHtmlToString } from "../../../../../config/utils";
import { DateDisplay } from "../../../../commonComponents/inline/dateDisplay/dateDisplay";
import { HyperLinkBuilder } from "../../../../commonComponents/inline/hyperLink";
import { SiteMedia } from "../../../../siteWidgets/siteMedia";
import { CalcalistMutamShareMenu } from "../../generalMutamComps/calcalistMutamShareMenu";

export interface videoList {
    video: SiteVideoData
    link: string
    linkTarget: LinkTargetProperties
    title: string
    roof?:string
    id: string
    subTitle?: string
    author?: string
    date?: Date
}

interface MobileTvCalcalistProps {
    videoItems: videoList[]
    videoSettings: VideoSettingsData
    numOfItems: number
    titleColor: string
    isDateVisible: boolean
    isAuthorVisible: boolean
    isSubTitleVisible?: boolean
    isHourVisible?: boolean
}

export class MobileTvCalcalist extends React.Component<MobileTvCalcalistProps, {}>{
    public static siteScriptName = "MobileTvCalcalist";
    constructor(props) {
        super(props);
    }

    render() {
        const { videoItems, videoSettings, titleColor, isAuthorVisible, isDateVisible } = this.props
        return (
            <div className="mobile-tv-calcalist">
                {videoItems.map((item, index) => {
                    if (item && index === 0) {
                        return (
                            <MobileTvCalcalistItem
                                key={item.id}
                                isMainItem={true}
                                item={item}
                                videoSettings={videoSettings}
                                titleColor={titleColor}
                                isAuthorVisible={isAuthorVisible}
                                isDateVisible={isDateVisible}
                            />
                        );
                    } else if (item && index === 1) {
                        return (
                            <div className="bottom-items" key="bottom-items">
                                <MobileTvCalcalistItem
                                    item={item}
                                    videoSettings={videoSettings}
                                    titleColor={titleColor}
                                    isAuthorVisible={isAuthorVisible}
                                    isDateVisible={isDateVisible}

                                />
                                {videoItems.length > 2 && (
                                    <MobileTvCalcalistItem
                                        item={videoItems[2]}
                                        videoSettings={videoSettings}
                                        titleColor={titleColor}
                                        isAuthorVisible={isAuthorVisible}
                                        isDateVisible={isDateVisible}
                                    />
                                )}
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        )
    }
}


interface MobileTvCalcalistItemProps {
    isMainItem?: boolean
    item: videoList
    videoSettings: VideoSettingsData
    titleColor: string
    isDateVisible: boolean
    isAuthorVisible: boolean
}

export class MobileTvCalcalistItem extends React.Component<MobileTvCalcalistItemProps, { videoPlayStarted: boolean }>{
    constructor(props) {
        super(props);
        this.state = {
            videoPlayStarted: false
        }
    }

    private handleOnVideoPlayStarted = () => {
        this.setState({ videoPlayStarted: true })
    }

    private handleOnVideoPlayStopped = () => {
        this.setState({ videoPlayStarted: false })
    }

    render() {
        const { item, titleColor, videoSettings, isMainItem, isDateVisible, isAuthorVisible } = this.props;
        const showMore = (isDateVisible && item.date) || (isAuthorVisible && item.author);
        const showBoth = (isDateVisible && item.date) && (isAuthorVisible && item.author);
        return (
            <div className="mobile-tv-calcalist-item">
                <div className="videoPlayerPlaceholder ">
                    {isMainItem && <CalcalistMutamShareMenu url={item.link} title={convertHtmlToString(item.title)} />}
                    {item.video !== null ? <SiteMedia
                        key={item.video.mediaId}
                        onPlayStarted={() => this.handleOnVideoPlayStarted()}
                        onPlayStopped={() => this.handleOnVideoPlayStopped()}
                        data={item.video} videoSettings={videoSettings} width={300} height={168} />
                        : <div />}
                </div>
                <div className="item-body">
                    <HyperLinkBuilder className="title" href={item.link} linkTarget={item.linkTarget}>
                    {isMainItem && item.roof && item.roof.length>0 && <div className="roofTitle" data-roof-text={item.roof}><span>{item.roof}</span></div>}
                       {isMainItem ?  <h5  dangerouslySetInnerHTML={{ __html: item.title }} /> : <span  dangerouslySetInnerHTML={{ __html: item.title }}/>}
                    </HyperLinkBuilder>
                    {showMore && <div className="more-details">
                        {isDateVisible && item.date && <span className="dateView"><DateDisplay date={item.date} hiddenYesterday={true} /> </span>}


                        {showBoth && <span className="commaView"> | </span>}
                        {item.author && isAuthorVisible && <span className="authorInfo" dangerouslySetInnerHTML={{ __html: item.author }} />}

                    </div>}
                </div>

            </div>
        )
    }


}